import { AnalyticsContext } from "@/Contexts/AnalyticsContext";
import { PopoverContext, PopoverId } from "@/Contexts/PopoverContext";
import classNames from "classnames";
import { useContext, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import Tooltip, { TooltipProps } from "./Tooltip";

export type PopoverTooltipProps = TooltipProps & {
    popoverId: PopoverId;
    dismissIsTemporary?: boolean;
    dismissForSeconds?: number;
};

export default function Popover({
    popoverId,
    dismissIsTemporary = false,
    dismissForSeconds,
    ...tooltipProps
}: PopoverTooltipProps) {
    const { markPopoverAsShown, arePopoversInitialized, popoverIdsShown } =
        useContext(PopoverContext);

    const analytics = useContext(AnalyticsContext);

    const canShow =
        !tooltipProps.disabled &&
        arePopoversInitialized &&
        !popoverIdsShown.has(popoverId);

    useEffect(() => {
        if (canShow) {
            analytics.trackEvent("popover_shown", {
                popover_id: popoverId,
            });
        }
    }, [canShow]);

    return (
        <Tooltip
            {...tooltipProps}
            popupContainerClassName={classNames(
                tooltipProps.popupContainerClassName,
                "shadow-xl drop-shadow-top",
            )}
            disabled={!canShow}
            bgColor="#FFFFFF"
            title={
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                <div
                    data-testid={popoverId}
                    className="relative text-brand-black"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="absolute -top-[10px] -right-[13px] flex items-center justify-center bg-brand-white hover:bg-brand-gray/30 rounded-full w-5.5 aspect-square shadow-lg">
                        <button
                            data-testid="close-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                markPopoverAsShown(
                                    popoverId,
                                    dismissIsTemporary,
                                    dismissForSeconds,
                                );
                            }}
                        >
                            <IoClose size={16} className="" />
                        </button>
                    </div>
                    {tooltipProps.title}
                </div>
            }
        />
    );
}
